import { SelectChangeEvent, SxProps, Theme } from '@mui/material';
import { GammaVannaModelChart } from 'components/indices/charts';
import { ExpandableContentWrapper } from 'components/shared';
import { CanvasContentId } from 'types/canvas';
import { GammaVannaModel, IndicesContentType } from 'types/indices';
import { getDefaultSymOptions } from 'util/indices';
import { CanvasGroupLinkButton } from 'components/canvas/groups';

interface CanvasGammaModelChartProps {
  id: number;
  sym: string;
  onSymChange: (sym: string) => void;
}

const CanvasGammaModelChart = ({
  id,
  sym,
  onSymChange,
}: CanvasGammaModelChartProps) => {
  const handleSymChange = (event: SelectChangeEvent<string>) => {
    const sym = event.target.value;
    onSymChange(sym ?? 'SPX');
  };

  const containerStyleOverrides: SxProps<Theme> = {
    height: '95%',
  };

  return (
    <ExpandableContentWrapper type={IndicesContentType.GAMMA_MODEL}>
      <GammaVannaModelChart
        model={GammaVannaModel.GAMMA}
        containerStyleOverrides={containerStyleOverrides}
        selectedSym={sym ?? 'SPX'}
        symSelectorSettings={{
          value: sym,
          options: getDefaultSymOptions(IndicesContentType.GAMMA_MODEL),
          onChange: handleSymChange,
        }}
        headerExtras={
          <CanvasGroupLinkButton
            componentId={id}
            contentId={CanvasContentId.GAMMA_MODEL_CHART}
          />
        }
      />
    </ExpandableContentWrapper>
  );
};

export default CanvasGammaModelChart;
